import React, { Component } from "react";
// import ReactDOM from "react-dom";
import Loader from "../common/Loader";
import Navbar from "../common/Navbar";
import FormLogin from "../subcompo/sections-login/FormLogin";
import FormReset from "../subcompo/sections-login/FormReset";
import Footer from "../common/Footer";
import FormChangePass from "../subcompo/sections-login/FormChangePass";
import Header from "../common/Header";
import Stats2 from "../subcompo/sections-home/Stats2";
// import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import SideTab from "../../newcomponent/common/SideTab";

import { GlobalAuthContext } from "../../context/AuthProvider";

let landingImage = require("../../images/GroupPhoto.png");
let isMobile = window.innerWidth < 900;
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedInUser: false,
      showLogin: "login",
    };
  }

  myRef = React.createRef();

  static contextType = GlobalAuthContext;

  async componentDidMount() {
    // ReactDOM.findDOMNode(this).scrollTop = 0;

    if (this?.myRef?.current) this.myRef.current.scrollTop = 0;

    const { user, allowedGroups } = this.context;

    try {
      let sessionData = user;
      if (sessionData) {
        let userGroups = allowedGroups;
        // sessionData.signInUserSession.accessToken.payload["cognito:groups"];
        this.setState({ userGroups, loggedInUser: true });
      }
    } catch (error) {
      this.setState({ loggedInUser: false, userGroups: [] });
    }
  }

  updateLoginShow = (value) => {
    this.setState({ showLogin: value });
  };
  render() {
    let { loggedInUser, userGroups } = this.state;
    return (
      <div>
        {/* <Navbar variant="large-logo" /> */}
        <div className="d-flex">
          <Header />
          {/* <Stats2 /> */}
        </div>
        <div className="position-relative">
          {isMobile && loggedInUser ? <SideTab /> : " "}
          <img
            width="100%"
            src={landingImage}
            alt="Landing Image"
            className="Landing__page__image"
          />
          <div className="workcomp-line">
            <p className="workcomp-line-paragraph">
              Workers’ Compensation Rater
            </p>
          </div>
          {!loggedInUser ? (
            <div
              className="tab-content tab-content-login"
              style={{ marginTop: "1.2rem", marginBottom: "1.2rem" }}
            >
              {this.state.showLogin === "login" && (
                <FormLogin updateLoginShow={this.updateLoginShow} />
              )}
              {this.state.showLogin === "change" && <FormChangePass />}
              {this.state.showLogin === "reset" && <FormReset />}

              <Loader />
            </div>
          ) : userGroups.includes(process.env.REACT_APP_GET_QUOTE_GROUP) ? (
            <div
              style={{
                display: "felx",
                flexDirection: "column",
                marginTop: "1.2rem",
                marginBottom: "1.2rem",
              }}
            >
              {/* <h1 style={{ textAlign: "center" }}>Already Logged In</h1> */}
              <h1 style={{ textAlign: "center" }} className="Startnewquotefont">
                <Link to={"/Quote"} style={{ color: "#497fbc" }}>
                  Start New Quote
                </Link>
              </h1>
            </div>
          ) : (
            <div></div>
          )}
          {/* <Footer /> */}
        </div>
      </div>
    );
  }
}

export default Login;
